<template>
	<div class="frame">
		<div class="frame-wrapper">
			<section class="frame-content">
				<div class="frame-viewer">
					<pdf
						ref="pdf"
						:spineAdjust="spineAdjust"
						:url="url"
						:zoom="zoom"
						:page="page"
						:unit="preferences.unit"
						:showOverview="preferences.showOverview"
						:showOverprint="preferences.showOverprint"
						:showInks="preferences.showInks"
						:showRulers="preferences.showRulers"
						:showBoxes="preferences.showBoxes"
						:selectedInks="preferences.selectedInks"
						:selectedBoxes="preferences.selectedBoxes"
						:changePage="changePage"
						:onFileLoaded="handleFileLoaded"
						:zoomEnd="zoomEnd"/>
				</div>
			</section>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Pdf from './Pdf.vue';
	import _get from 'lodash/get';
	import _isEmpty from 'lodash/isEmpty'

	export default {
		props: ['url'],
		data() {
			return {
				spineAdjust: {},
				page: 1,
				zoom: 5,
				zoom100: 5,
				preferences: {
					showOverview: true,
					showOverprint: false,
					showRulers: true,
					showInks: false,
					showBoxes: true,
					unit: "mm",
					selectedInks: [],
					selectedBoxes: []
				},
				parentWindow: null,
				parentUrl: null
			}
		},
		components: {
			Pdf
		},
		async created() {
			//this.parentWindow = window.parent;
			// provide control access to outside the iframe
			await this.bindMessaging();
			this.sendPreferences();
		},
		methods: {
			bindMessaging(){
				window.addEventListener("message", ({ data }) => {
					const { command, args } = data;
					if (command === "zoomIn" && this.zoom < 12) this.zoom = Math.floor(this.zoom + 1);
					if (command === "zoomOut" && this.zoom > 1) this.zoom = Math.ceil(this.zoom - 1);
					if (command === "actualSize") this.zoom = this.zoom100;
					if (command === "setSpines") this.setSpines(args);
					if (command === "fitToPage") this.fitTo('page');
					if (command === "fitToWidth") this.fitTo('width');
					if (command === "nextPage") this.nextPage();
					if (command === "prevPage") this.prevPage();
					if (command === "changePage") this.changePage(args);
					if (command === 'setPreferences') {
						const { key, value } = args;
						this.preferences[key] = value;
					}
					if (command === 'setPreferencesUnit') {
						this.preferences.unit = args;
					}
					this.sendPreferences();
				}, false);

				this.parentUrl = new Promise(resolve => {
					window.addEventListener("message", ({ data }) => {
						const { command, args } = data;
						if (command === "setParentUrl") {
							resolve(args);
							this.postMessageToParent('ready');
						}
					});
				});

				return this.parentUrl;
			},
			sendPreferences(){
				this.postMessageToParent('setPreferences', this.preferences);
			},
			nextPage() {
				// need to add a check for end of document
				this.page++;
				this.postMessageToParent('pageChanged', this.page);
			},
			prevPage() {
				if (this.page < 2)    return;
				this.page--;
				this.postMessageToParent('pageChanged', this.page);
			},
			goToPage(page) {
				this.page = parseInt(page);
				this.postMessageToParent('pageChanged', this.page);
			},
			changePage(page) {
				this.page = parseInt(page);
				this.postMessageToParent('pageChanged', this.page);
			},
			handleFileLoaded(view){
				if (_isEmpty(this.preferences.selectedInks)){
					this.preferences.selectedInks = view.data.page.inks.map(ink => ink.colorantName) || [];
				}
				if (_isEmpty(this.preferences.selectedBoxes)) {
					this.preferences.selectedBoxes = view.data.page.boxes.map(box => box.type) || [];
				}
				this.postMessageToParent('viewInfo', view);
				this.sendPreferences();
			},
			async postMessageToParent(command, args) {
				const parentUrl = await this.parentUrl;
				window.parent.postMessage({ command, args }, parentUrl);
			},
			zoomEnd(zoom) {
				this.zoom = zoom;
			},
			setSpines(spineAdjust) {
				this.spineAdjust = spineAdjust;
			},
			fitTo(target) {
				this.$refs.pdf.fitTo(target)
			}
		}
	}

</script>
<style>
.frame {
	width: 100%;
	height: 100vh;
}
.frame-wrapper {
	padding: 0;
	display: flex;
	flex-direction: column;
	height: 100%;
}
.frame-content {
	flex-grow: 1;
	margin: 0 0px;
	display: flex;
}
.frame-viewer{
	display: flex;
	padding: 0;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// Frame.vue?d5cc2fde